module.exports = "/assets/about/success/fba2024.jpg?0uXRrx1";